import { render } from "./ManageTasksModal.vue?vue&type=template&id=ec1d486c&scoped=true"
import script from "./ManageTasksModal.vue?vue&type=script&lang=js"
export * from "./ManageTasksModal.vue?vue&type=script&lang=js"

import "./ManageTasksModal.vue?vue&type=style&index=0&id=ec1d486c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ec1d486c"

export default script